import { OrderSortType } from '../redux/operation/operationsInterface';

const defaultElementsByPage = 20;
const defaultOrder = 'DATE';
const defaultSort = 'DESC';

const MethodDashboard = (URL: string, search?: any, orderBy?: OrderSortType) => {
  let defaultPage = 0;
  if (search && search.offset) {
    defaultPage = search.offset;
  }
  let defaultURL = URL.replace('<offset>', defaultPage.toString())
    .replace('<limit>', search.limit.toString() || defaultElementsByPage.toString())
    .replace('<order>', orderBy?.order ?? defaultOrder)
    .replace('<sort>', orderBy?.sort ?? defaultSort);
    // .replace("<from_date>", search.from_date.toString())
    // .replace("<to_date>", search.to_date.toString())
  if (search) {
    const {
      buttons, cart_id, from_date, nameOrDni, to_date, credit_proposal_id, proposal_reference,
    } = search;
    const queryParams = [];
    if (buttons) {
      queryParams.push(`${buttons}`);
    }
    if (cart_id) {
      queryParams.push(`${cart_id}`);
    }
    if (proposal_reference) {
      queryParams.push(`${proposal_reference}`);
    }
    if (from_date) {
      queryParams.push(`${from_date}`);
    }
    if (nameOrDni) {
      queryParams.push(`${nameOrDni}`);
    }
    if (to_date) {
      queryParams.push(`${to_date}`);
    }
    if (credit_proposal_id) {
      queryParams.push(`&credit_proposal_id=${credit_proposal_id}`);
    }
    if (queryParams.length > 0) {
      defaultURL += `${queryParams.join('')}`;
    }
  }
  return defaultURL;
};

export default MethodDashboard;
